import React from "react";

const SubmitButton = ({ text }) => {
    const className = "font-bold self-start cursor-pointer shadow-lg red-card white-text rounded-xl px-5 py-1.5 my-2 submit";
    return <input type="submit" value={text} className={className} />;
};

export default SubmitButton;
